import { Helmet } from "react-helmet-async";

const SITE_NAME = "Fresh Po'Boy Streetwear";
const SITE_URL = "https://freshpoboy.store";
const DEFAULT_IMAGE = "https://freshpoboy.store/images/air_jordan_frame.jpg";

export function SEO({ title, description, path = "", image, type = "website", product }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;
  const desc = description || "Premium streetwear that speaks to the culture. T-Shirts, Hoodies & Sweaties. 10% OFF everything. Shop now at Fresh Po'Boy.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {/* Product structured data */}
      {product && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            "name": product.name,
            "image": product.image,
            "description": product.description,
            "brand": { "@type": "Brand", "name": SITE_NAME },
            "offers": {
              "@type": "Offer",
              "price": product.price,
              "priceCurrency": "USD",
              "availability": "https://schema.org/InStock",
              "url": `${SITE_URL}/product/${product.id}`
            }
          })}
        </script>
      )}
    </Helmet>
  );
}
